<template>
  <div class="card mb-4">
    <div class="card-header pb-0">
      <div class="row">
        <div class="col">
          <h6>Registro de usuarios</h6>
        </div>
      </div>
    </div>
    <div class="card-body px-4">
      <div class="table-responsive">
        <div class="d-flex justify-content-between">
          <div class="w-25">
            <select name="per_page" id="per_page" v-model="pagination.limit" class="form-control" @click="reloadPaginate(1)">
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="200">200</option>
            </select>
          </div>
        </div>
        <table class="table table-bordered table-sm">
          <thead>
          <tr>
            <th>Prospecto</th>
            <th>Agente</th>
            <th>Descripción</th>
            <th>Fecha</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in arrayLogs" :key="index">
            <td class="text-uppercase text-xs font-weight-bold mb-0">{{item.name}} - {{item.email}}</td>
            <td class="text-uppercase text-xs font-weight-bold mb-0">{{item.agent_name}} - {{item.agent_email}}</td>
            <td class="text-uppercase text-xs font-weight-bold mb-0">{{item.description}}</td>
            <td class="text-uppercase text-xs font-weight-bold mb-0">{{$filters.formatDate(item.created_at)}}</td>
          </tr>
          </tbody>
        </table>
        <div class="d-flex justify-content-between">
          <div>
            <p class="text-xs font-weight-bold mb-0">Total de filas: {{pagination.totalRows}}</p>
          </div>
          <div>
            <v-pagination
                v-model="pagination.page"
                :pages="pagination.pages"
                :range-size="1"
                active-color="#DCEDFF"
                @update:modelValue="reloadPaginate"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {get} from "@/utils/httpRequest";

export default {
  name: "Index",
  data: () => ({
    arrayLogs: [],
    pagination: {
      searchTimer: null,
      page: 1,
      pages: 0,
      limit: 20,
      search: '',
      totalRows: 0
    }
  }),
  mounted() {
  this.getLogs()
    },
  methods: {
    async getLogs(){
      const {data} = await get(`users/get-all-user-request?page=${this.pagination.page}&limit=${this.pagination.limit}&search=${this.pagination.search}`)
      this.arrayLogs = data.docs
      this.pagination.totalRows = data.count
      this.pagination.page = data.page
      this.pagination.pages = data.pages
    },
    reloadPaginate(page){
      this.pagination.page = page
      this.getLogs()
    },
    manualSearch(){
      clearTimeout(this.pagination.searchTimer);
      this.pagination.searchTimer = setTimeout(() => {
        this.reloadPaginate(1)
      }, 2000);
    },
  }
}
</script>

<style scoped>

</style>
